import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 40px 0;
  overflow: hidden;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  padding: 0 40px 80px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 100px;
  margin-top: 50px;

  @media (max-width: 1024px) {
    gap: 40px;
  }

  @media (max-width: 768px) {
    display: block;
  }

  form {
    max-width: 630px;

    @media (max-width: 768px) {
      max-width: 100%;
    }

    h1 {
      font-family: 'Avenir Next LT Pro Bold';
      font-size: 45px;
      line-height: 140%;
      color: #fff;

      @media (max-width: 414px) {
        font-size: 30px;
      }
    }

    @media (max-width: 414px) {
      div {
        margin-bottom: 20px;
      }
    }

    .form-group {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      div {
        margin-right: 20px;
      }

      div + div {
        margin-left: 20px;
        margin-right: 0px;
      }

      @media (max-width: 414px) {
        flex-direction: column;

        div {
          margin-right: 0px;
          margin-bottom: 20px;
        }

        div + div {
          margin: 0px;
        }
      }
    }

    button[type='submit'] {
      font-family: 'Avenir Next LT Pro Regular';
      padding: 10px 30px 6px;
      margin-right: 20px;
      background: transparent;
      border-radius: 20px;
      border: 2px solid #fff;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.4s;
      margin-top: 50px;

      &:hover {
        background-color: #fff;
        color: #100f12;
      }
    }

    fieldset {
      margin-top: 40px;
      border: 0;
      text-align: center;
      width: 100%;

      @media (max-width: 414px) {
        margin-top: 20px;
      }

      legend p {
        font-size: 18px;
        color: #5eeddc;
        margin-bottom: 10px;
      }

      .services {
        display: flex;
        flex-direction: column;

        div {
          margin-top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;

          button {
            font-family: 'Avenir Next LT Pro Bold';
            padding: 10px 30px 6px;
            margin-right: 20px;
            background: transparent;
            border-radius: 20px;
            border: 2px solid #fff;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all 0.4s;

            @media (max-width: 1024px) {
              font-size: 14px;
              padding: 10px 20px 6px;
            }

            @media (max-width: 414px) {
              font-size: 12px;
              padding: 10px 10px 6px;
              margin-right: 10px;
            }

            &:hover {
              background-color: #fff;
              color: #100f12;
            }

            &.selected {
              background-color: #fff;
              color: #100f12;
            }
          }
        }
      }
    }
  }

  .info {
    margin-top: 15%;

    h3 {
      font-size: 22px;
      line-height: 150%;
      color: #fff;
      font-family: 'Avenir Next LT Pro Regular';
    }

    ul {
      list-style: none;
      margin-top: 10px;

      li {
        margin: 20px 0;
        display: flex;

        svg {
          color: #5eeddc;
        }

        p {
          font-family: 'Avenir Next LT Pro Regular';
          font-size: 16px;
          line-height: 150%;
          margin-left: 20px;
          color: #ddd;
          flex: 1;
        }
      }
    }
  }
`;
